let wurflPromise = null

function withTimeout (promise, timeoutMs) {
  if (timeoutMs == null) {
    return promise
  }
  return new Promise((resolve) => {
    let settled = false
    const timerId = setTimeout(() => {
      if (!settled) {
        settled = true
        console.warn(`Загрузка WURFL превысила ${timeoutMs}мс`)
        resolve(null)
      }
    }, timeoutMs)

    promise.then((data) => {
      if (!settled) {
        settled = true
        clearTimeout(timerId)
        resolve(data)
      }
    })
  })
}

export function loadWurfl (timeoutMs) {
  if (window.WURFL) {
    return Promise.resolve(window.WURFL)
  }

  if (!wurflPromise) {
    wurflPromise = new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = 'https://wurfl.io/wurfl.js'
      script.async = true
      document.head.appendChild(script)

      let resolved = false
      const finish = (data) => {
        if (!resolved) {
          if (data != null) {
            console.log('Загрука WURFL завершена успешно. WURFL: ', data)
          } else {
            console.warn('Загрука WURFL не удалась')
          }
          resolved = true
          resolve(data)
        }
      }

      script.onerror = () => {
        console.warn('Ошибка загрузки WURFL')
        finish(null)
      }

      document.addEventListener('WurflJSDetectionComplete', () => {
        finish(window.WURFL || null)
      })

      script.onload = () => {
        if (window.WURFL) {
          finish(window.WURFL)
        }
      }
    })
  }

  return withTimeout(wurflPromise, timeoutMs)
}
